import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconVideoOn"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H14.5C15.8807 4 17 5.11929 17 6.5V7.69098L19.8292 6.27639C20.8265 5.77772 22 6.50296 22 7.61803V16.382C22 17.497 20.8265 18.2223 19.8292 17.7236L17 16.309V17.5C17 18.8807 15.8807 20 14.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM9.5 15C11.1569 15 12.5 13.6569 12.5 12C12.5 10.3431 11.1569 9 9.5 9C7.84315 9 6.5 10.3431 6.5 12C6.5 13.6569 7.84315 15 9.5 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoOn;
